import React from 'react';
import { Router as RouterProvider } from 'react-router-dom';
import ToastProvider from './components/Toast/ToastProvider';
import { Router, history } from './router';
import { IframeProvider } from './contexts/IframeContext';
import './styles/global.css';

function App() {
  return (
    <ToastProvider>
      <IframeProvider>
        <RouterProvider history={history}>
          <Router />
        </RouterProvider>
      </IframeProvider>
    </ToastProvider>
  );
}

export default App;
